import { LegalShell, Section } from "@/components/LegalShell";

export default function Privacy() {
  return (
    <LegalShell title="Privacy Policy" subtitle="GDPR" updated="February 2026">
      <Section title="1. Data controller">
        <p>SiteCrews is the data controller for personal data processed through this platform. Contact our DPO at <a className="text-amber-500 hover:underline" href="mailto:hello@sitecrews.net">hello@sitecrews.net</a>.</p>
      </Section>
      <Section title="2. What we collect">
        <ul className="list-disc pl-6 space-y-1">
          <li><b>Account:</b> name, email, phone, county, role, hashed password</li>
          <li><b>Content:</b> job posts, availability posts and applications you create</li>
          <li><b>Payment:</b> transaction records for boosts (payment card data is handled by Stripe, not by us)</li>
          <li><b>Technical:</b> session cookie for authentication, minimal server logs</li>
        </ul>
      </Section>
      <Section title="3. Why we process it (lawful bases)">
        <ul className="list-disc pl-6 space-y-1">
          <li><b>Contract</b> — to provide the marketplace service you signed up for (Art. 6(1)(b) GDPR)</li>
          <li><b>Legitimate interests</b> — service security, fraud prevention (Art. 6(1)(f))</li>
          <li><b>Legal obligation</b> — tax, accounting and law enforcement requests (Art. 6(1)(c))</li>
        </ul>
      </Section>
      <Section title="4. Contact reveal">
        <p>When someone applies to your job or contacts your availability post, the applicant&apos;s name, email and (if provided) phone number are shown to you. Users are expected to only use these details for the purpose of arranging work.</p>
      </Section>
      <Section title="5. Sharing">
        <p>We share data only with essential processors: Stripe (payments), our cloud infrastructure provider, and law enforcement where required. We never sell your data.</p>
      </Section>
      <Section title="6. Retention">
        <p>Account data is kept while your account is active and for up to 2 years after closure for legal/accounting purposes. You can request deletion at any time.</p>
      </Section>
      <Section title="7. Your rights">
        <p>Under GDPR you have the right to access, rectify, erase, restrict, port and object to processing of your personal data. To exercise any of these rights email <a className="text-amber-500 hover:underline" href="mailto:hello@sitecrews.net">hello@sitecrews.net</a>. You can also complain to the Data Protection Commission (dataprotection.ie).</p>
      </Section>
      <Section title="8. International transfers">
        <p>Some of our processors may transfer data outside the EEA under Standard Contractual Clauses or an adequacy decision.</p>
      </Section>
      <Section title="9. Changes">
        <p>We may update this policy. Material changes will be communicated in-app or by email.</p>
      </Section>
    </LegalShell>
  );
}
